"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var TxMultimediaDisplayComponent = /** @class */ (function () {
    function TxMultimediaDisplayComponent() {
        this.txOnRemoveFileFromList = new core_1.EventEmitter();
    }
    Object.defineProperty(TxMultimediaDisplayComponent.prototype, "file", {
        get: function () {
            return this._file;
        },
        set: function (file) {
            this._file = file;
            this.setFileType();
        },
        enumerable: true,
        configurable: true
    });
    TxMultimediaDisplayComponent.prototype.ngOnInit = function () {
    };
    TxMultimediaDisplayComponent.prototype.removeFileFromList = function () {
        this.txOnRemoveFileFromList.emit(this.file);
    };
    TxMultimediaDisplayComponent.prototype.setFileType = function () {
        try {
            this.notVideoOrImage = !this.file.fileType.match(/IMAGE/)
                && !this.file.fileType.match(/VIDEO/);
        }
        catch (e) {
            this.notVideoOrImage = !this.file.file.type.match(/image\/\w+/)
                && !this.file.file.type.match(/video\/\w+/);
        }
    };
    TxMultimediaDisplayComponent.prototype.openFile = function () {
        window.open(this.file.path, '_blank');
    };
    TxMultimediaDisplayComponent.prototype.isImage = function () {
        try {
            return this.file.fileType.match(/IMAGE/);
        }
        catch (e) {
            return this.file.file.type.match(/image\/\w+/);
        }
    };
    TxMultimediaDisplayComponent.prototype.isVideo = function () {
        try {
            return this.file.fileType.match(/VIDEO/);
        }
        catch (e) {
            return this.file.file.type.match(/video\/\w+/);
        }
    };
    TxMultimediaDisplayComponent.ctorParameters = function () { return []; };
    return TxMultimediaDisplayComponent;
}());
exports.TxMultimediaDisplayComponent = TxMultimediaDisplayComponent;
//# sourceMappingURL=tx-multimedia-display.component.js.map


// WEBPACK FOOTER //
// tx-multimedia-display.component.js